/* eslint-disable no-param-reassign */
const $ = require('lib/jquery')

const cache = {}

function getScript(url, options) {

    options = $.extend(options || {}, {
        dataType: 'script',
        url,
    })

    return $.ajax(options)
}

function getCachedScript(url, options) {
    let xhr = cache[url]

    if (! xhr) {
        // not cached yet, so fetch the script
        xhr = getScript(url, options)

        // cache the response
        cache[url] = xhr
    }

    return xhr
}

module.exports = getCachedScript
